import React, { useCallback } from "react";
import { Checkbox, FormControlLabel } from "@material-ui/core";

import { MaintenanceWindow } from "../../../../../dtos/site";

type DayKey = keyof Pick<MaintenanceWindow, "monday" | "tuesday" | "wednesday" | "thursday" | "friday" | "saturday" | "sunday">;

interface Props {
    dayKey: DayKey;
    value: boolean;
    onChange: (partialConfig: Partial<MaintenanceWindow>) => void;
    disabled?: boolean;
}

export function MaintenanceDayField({
    dayKey,
    value,
    onChange,
    disabled = false,
}: Props) {
    const inputId = `maintenance_${dayKey}`;

    const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        if (disabled) return;
        onChange({ [dayKey]: e.target.checked });
    }, [dayKey, onChange, disabled]);

    return (
        <FormControlLabel
            control={
                <Checkbox
                    value={value}
                    color="primary"
                    onChange={handleChange}
                    checked={value}
                />
            }
            label={dayKey.charAt(0).toUpperCase() + dayKey.slice(1)}
            htmlFor={inputId}
            disabled={disabled}
        />
    );
}
